module.exports = __webpack_public_path__ + "img/no-data1.16f84950.png";